import React from "react";

import { DeploymentOverlay, getDefaultOverlayCopy } from "./DeploymentOverlay";
import { deploymentConfig } from "./deploymentConfig";
import { useDeployment } from "./useDeployment";
import type { DeploymentConfig } from "./types";

export interface DeploymentManagerProps {
  /**
   * Optional configuration override.
   * Defaults to `deploymentConfig` — change that file to retarget another SPA.
   */
  config?: DeploymentConfig;
}

/**
 * Application integration entry point for the Deployment Update Framework.
 *
 * Mount once inside the router tree. No other application code should
 * import from this package directly.
 */
export function DeploymentManager({
  config = deploymentConfig,
}: DeploymentManagerProps) {
  const { phase, countdownSeconds, requestReload } = useDeployment(config);

  if (!config.enabled || phase !== "update-pending") {
    return null;
  }

  return (
    <DeploymentOverlay
      copy={config.overlay ?? getDefaultOverlayCopy()}
      countdownSeconds={countdownSeconds}
      onUpdateNow={requestReload}
    />
  );
}
